import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _excluded = ["tags", "access", "accesses", "latest_version", "date_created", "date_modified", "can_edit", "owner_id", "owner_public_id", "workspace_id", "history"];
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _Document;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import uniq from 'lodash/uniq';
import map from 'lodash/map';
import flatMap from 'lodash/flatMap';
import pick from 'lodash/pick';
import orderBy from 'lodash/orderBy';
import moment from 'moment';
import { observable, computed } from 'mobx';
import { Model, referenceMany } from 'libx';
import { required, func } from 'validx';
var Document = (_class = (_Document = /*#__PURE__*/function (_Model) {
  function Document() {
    var _this;
    _classCallCheck(this, Document);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Document, [].concat(args));
    _initializerDefineProperty(_this, "title", _descriptor, _this);
    _initializerDefineProperty(_this, "workspaceId", _descriptor2, _this);
    _initializerDefineProperty(_this, "description", _descriptor3, _this);
    _initializerDefineProperty(_this, "archived", _descriptor4, _this);
    _initializerDefineProperty(_this, "canEdit", _descriptor5, _this);
    _initializerDefineProperty(_this, "ownerId", _descriptor6, _this);
    _initializerDefineProperty(_this, "ownerPublicId", _descriptor7, _this);
    _initializerDefineProperty(_this, "tagIds", _descriptor8, _this);
    _initializerDefineProperty(_this, "documentType", _descriptor9, _this);
    _initializerDefineProperty(_this, "dateCreated", _descriptor10, _this);
    _initializerDefineProperty(_this, "dateModified", _descriptor11, _this);
    // When uploading a new version,
    // this is set on the document so
    // the view can display progress.
    _initializerDefineProperty(_this, "uploadProgress", _descriptor12, _this);
    return _this;
  }
  _inherits(Document, _Model);
  return _createClass(Document, [{
    key: "tags",
    get: function get() {
      var tags = this.rootStore.documentTagStore.tags;
      return referenceMany(tags, this.tagIds, 'id');
    }

    /**
     * @type {Array<import('./DocumentAccess').default>}
     */
  }, {
    key: "accesses",
    get: function get() {
      return orderBy(referenceMany(this.rootStore.documentAccessStore.accesses, this.id, 'documentId'), 'dateCreated', 'desc');
    }

    /**
     * @type {Array<import('./DocumentVersion').default>}
     */
  }, {
    key: "history",
    get: function get() {
      var versions = referenceMany(this.rootStore.documentVersionStore.versions, this.id, 'documentId');
      return orderBy(versions, 'dateCreated', 'desc');
    }
  }, {
    key: "latestVersion",
    get: function get() {
      return this.history[0];
    }
  }, {
    key: "owner",
    get: function get() {
      return this.rootStore.memberStore.forWorkspaceAndUserPublicId(this.workspaceId, this.ownerPublicId);
    }
  }, {
    key: "collaborators",
    get: function get() {
      return uniq(flatMap(this.history, function (version) {
        return version.author;
      })).filter(Boolean);
    }
  }, {
    key: "canManageAccess",
    get: function get() {
      var currentUser = this.rootStore.authStore.user;
      if (!this.owner) {
        return false;
      }
      // TODO: API should determine this.
      return this.owner.userId === currentUser.userId;
    }
  }, {
    key: "isAuthor",
    get: function get() {
      if (!this.latestVersion) {
        return false;
      }
      var currentUser = this.rootStore.authStore.user;
      return this.latestVersion.authorPublicId === currentUser.userPublicId;
    }
  }, {
    key: "parse",
    value: function parse(_ref) {
      var tags = _ref.tags,
        access = _ref.access,
        _ref$accesses = _ref.accesses,
        accesses = _ref$accesses === void 0 ? [] : _ref$accesses,
        latest_version = _ref.latest_version,
        date_created = _ref.date_created,
        date_modified = _ref.date_modified,
        can_edit = _ref.can_edit,
        owner_id = _ref.owner_id,
        owner_public_id = _ref.owner_public_id,
        workspace_id = _ref.workspace_id,
        _ref$history = _ref.history,
        history = _ref$history === void 0 ? [] : _ref$history,
        json = _objectWithoutProperties(_ref, _excluded);
      var _this$rootStore = this.rootStore,
        documentAccessStore = _this$rootStore.documentAccessStore,
        documentTagStore = _this$rootStore.documentTagStore,
        documentVersionStore = _this$rootStore.documentVersionStore,
        memberStore = _this$rootStore.memberStore;
      var tagIds = this.tagIds.slice();
      documentAccessStore.accesses.set(access);
      documentAccessStore.accesses.set(accesses);
      documentTagStore.tags.set(tags);
      documentVersionStore.versions.set(history);
      documentVersionStore.versions.set(latest_version);

      // Since tags are managed when saving the doc itself,
      // and since tags are not filtered in any way by perms,
      // replace entirely when an update comes in.
      // Also, tags do not have a reference field and are
      // shared among multiple docs, so therefore we maintain an ID list.
      if (tags) {
        tagIds = map(tags, 'id');
      }
      if (owner_id && workspace_id) {
        memberStore.setAndFetch({
          workspace_id: workspace_id,
          user_id: owner_id,
          user_public_id: owner_public_id
        });
      }
      return _objectSpread(_objectSpread({}, pick(json, ['id', 'title', 'description', 'archived', 'uploadProgress'])), {}, {
        workspaceId: workspace_id,
        ownerId: owner_id,
        ownerPublicId: owner_public_id,
        canEdit: can_edit,
        tagIds: uniq(tagIds),
        dateCreated: moment(date_created || this.dateCreated),
        dateModified: moment(date_modified || this.dateModified),
        documentType: json.document_type ? {
          id: json.document_type.id,
          name: json.document_type.name,
          shortId: json.document_type.short_id,
          uploaderUserType: json.document_type.uploader_user_type
        } : json.document_type
      });
    }
  }]);
}(Model), _Document.validationRules = {
  title: [required('Title is required'), func(function (opts) {
    return opts.value.length >= 2;
  }, 'Too short.'), func(function (opts) {
    return opts.value.length <= 80;
  }, 'Too long.')]
}, _Document), _descriptor = _applyDecoratedDescriptor(_class.prototype, "title", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "workspaceId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "description", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "archived", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "canEdit", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "ownerId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "ownerPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "tagIds", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "documentType", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "dateCreated", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "dateModified", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "uploadProgress", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "tags", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "tags"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "accesses", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "accesses"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "history", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "history"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "latestVersion", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "latestVersion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "owner", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "owner"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "collaborators", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "collaborators"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "canManageAccess", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "canManageAccess"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAuthor", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAuthor"), _class.prototype), _class);
export { Document as default };
//# sourceMappingURL=Document.js.map
